const DB_NAME = window?.env?.INDEX_DB_NAME;
let DB_VERSION = window?.env?.INDEX_DB_VERSION;

let db;
const indexedDBobject =
  window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB;
const DBOpenRequest = indexedDBobject.open(DB_NAME, DB_VERSION);

DBOpenRequest.onsuccess = (event) => {
  console.log(
    "connected successfully",
    event.target.result.version,
    DB_VERSION
  );
  if (event.target.result.version < DB_VERSION) {
    event.target.result.onversionchange = true;
  }
  db = event.target.result;
};

DBOpenRequest.onerror = (event) => {
  console.log("Oops, failed to connect", { event });
};

// db.source.update
DBOpenRequest.onupgradeneeded = (event) => {
  // const  = event.target.result;
  const request = event.target.result;
  console.log("upgrade needed", { request });
  request.createObjectStore("patients", {
    keyPath: "localID",
    autoIncrement: true,
  });
  request.createObjectStore("selectedpatient", {
    keyPath: "id",
    autoIncrement: true,
  });
  request.createObjectStore("priscriptions", {
    keyPath: "localID",
    autoIncrement: true,
  });
  request.createObjectStore("selectedPriscriptions", {
    keyPath: "id",
    autoIncrement: true,
  });
  request.createObjectStore("selectedAppointments", {
    keyPath: "id",
    autoIncrement: true,
  });
  request.createObjectStore("appointments", {
    keyPath: "localID",
    autoIncrement: true,
  });
  request.createObjectStore("selectedBilling", {
    keyPath: "id",
    autoIncrement: true,
  });
  request.createObjectStore("billings", {
    keyPath: "localID",
    autoIncrement: true,
  });
  request.createObjectStore("selectedPartner", {
    keyPath: "id",
    autoIncrement: true,
  });
  request.createObjectStore("partner", {
    keyPath: "localID",
    autoIncrement: true,
  });
  request.createObjectStore("selectedInventory", {
    keyPath: "id",
    autoIncrement: true,
  });
  request.createObjectStore("inventory", {
    keyPath: "localID",
    autoIncrement: true,
  });
  request.createObjectStore("selectedHelpDesk", {
    keyPath: "id",
    autoIncrement: true,
  });
  request.createObjectStore("helpDesk", {
    keyPath: "localID",
    autoIncrement: true,
  });
  request.createObjectStore("patientNotes", {
    keyPath: "localID",
    autoIncrement: true,
  });
  request.createObjectStore("selectedPatientNotes", {
    keyPath: "id",
    autoIncrement: true,
  });
  request.createObjectStore("documents", {
    keyPath: "localID",
    autoIncrement: true,
  });

  request.onerror = (error) => {
    console.log({ error }, "Error creating store objects");
    throw new Error(error);
  };
};

// Patients
export const addPatient = async (data) => {
  const transaction = db.transaction("patients", "readwrite");
  const store = transaction.objectStore("patients");
  await store.add(data);
};

// working update/put method
export const editPatient = async (data) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("patients", "readwrite");
    const store = transaction.objectStore("patients");
    // Get the patient list object that has this localID as its localID
    const objectStoreWithID = store.get(data.localID);
    objectStoreWithID.onsuccess = () => {
      // Grab the data object returned as the result by: objectStoreWithID.result
      const myData = data;
      // Create another request that inserts the item back into the myDatabase
      const updateTitleRequest = store.put(myData);
      // Log the transaction that originated this request
      return resolve({ status: "Updated" });
    };
    objectStoreWithID.onerror = (event) => {
      return reject(console.log({ event }));
    };
  });
};
export const getPatient = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("patients", "readonly");
    const store = transaction.objectStore("patients");
    const stores = store.get(id);
    stores.onsuccess = function (e) {
      resolve(e.target.result);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};

export const getAllPatients = async () => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("patients", "readonly");
    const store = transaction.objectStore("patients");
    const stores = store.getAll();
    stores.onsuccess = function (e) {
      resolve(e.target.result);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};

export const deletePatient = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("patients", "readwrite");
    const store = transaction.objectStore("patients");
    const objectStoreWithID = store.get(id);
    objectStoreWithID.onsuccess = () => {
      // Grab the data object returned as the result by: objectStoreWithID.result
      // const myData = data;
      // Create another request that inserts the item back into the myDatabase
      const updateTitleRequest = store.delete(id);
      // Log the transaction that originated this request
      return resolve(console.log("Deleted"));
    };
    objectStoreWithID.onerror = (event) => {
      return reject(console.log({ event }));
    };
    // await store.delete(id);
    // store.onsuccess = function (e) {
    //   resolve('success')
    // }
    // store.onerror = function (e) {
    //   reject('error')
    // }
  });
};

export const saveSelectedPatient = async (data) => {
  const transaction = db.transaction("selectedpatient", "readwrite");
  const store = transaction.objectStore("selectedpatient");
  await store.clear();
  await store.add(data);
};

export const getSelectedPatient = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("selectedpatient", "readonly");
    const store = transaction.objectStore("selectedpatient");
    const stores = store.getAll();
    stores.onsuccess = function (e) {
      resolve(e.target.result);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};
export const deleteSelectedPatient = async (id) => {
  // console.log('id from indexdb', id);
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("selectedpatient", "readwrite");
    const store = transaction.objectStore("selectedpatient");
    // console.log('id from indexdb', id);
    await store.clear();
    store.onsuccess = function (e) {
      resolve("success");
    };
    store.onerror = function (e) {
      reject("error");
    };
  });
};
export const getPatientByID = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("patients", "readonly");
    const store = transaction.objectStore("patients");

    const stores = store.getAll();
    stores.onsuccess = function (e) {
      let users = e.target.result;
      let matchingUsers = users.filter((user) => user.localID === id);
      resolve(matchingUsers);
    };
    stores.onerror = (e) => {
      console.error(e?.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};

// Prescriptions
export const addPriscription = async (data) => {
  const transaction = db.transaction("priscriptions", "readwrite");
  const store = transaction.objectStore("priscriptions");
  await store.add(data);
};
export const editPriscriptions = async (data) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("priscriptions", "readwrite");
    const store = transaction.objectStore("priscriptions");
    // Get the priscriptionslist object that has this localID as its localID
    const objectStoreWithID = store.get(data.localID);
    objectStoreWithID.onsuccess = () => {
      // Grab the data object returned as the result by: objectStoreWithID.result
      const myData = data;
      // Create another request that inserts the item back into the myDatabase
      const updateTitleRequest = store.put(myData);
      // Log the transaction that originated this request
      return resolve(console.log("Updated"));
    };
    objectStoreWithID.onerror = (event) => {
      return reject(console.log({ event }));
    };
  });
};
export const getPriscriptions = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("priscriptions", "readonly");
    if (!transaction) reject(console.log("Cannot access transactions"));
    const store = transaction.objectStore("priscriptions");
    const stores = store.get(id);
    stores.onsuccess = function (e) {
      resolve(e.target.result);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};
export const getAllPriscriptions = async () => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("priscriptions", "readonly");
    if (!transaction) reject(console.log("Cannot access transactions"));
    const store = transaction.objectStore("priscriptions");
    const stores = store.getAll();
    stores.onsuccess = function (e) {
      resolve(e.target.result);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};
export const deletePriscription = async (id) => {
  console.log(id);
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("priscriptions", "readwrite");
    const store = transaction.objectStore("priscriptions");
    const objectStoreWithID = store.get(id);
    if (!objectStoreWithID) reject("could not get record deleted");
    objectStoreWithID.onsuccess = () => {
      // Grab the data object returned as the result by: objectStoreWithID.result
      // const myData = data;
      // Create another request that inserts the item back into the myDatabase
      const updateTitleRequest = store.delete(id);
      // Log the transaction that originated this request
      return resolve(
        { message: "Record Deleted" }
        // console.log('Deleted')
      );
    };
    objectStoreWithID.onerror = (event) => {
      return reject({ message: event.result });
    };
    // await store.delete(id);
    // store.onsuccess = function (e) {
    //   resolve('success')
    // }
    // store.onerror = function (e) {
    //   reject('error')
    // }
  });
};
export const saveSelectedPriscription = async (data) => {
  const transaction = db.transaction("selectedPriscriptions", "readwrite");
  const store = transaction.objectStore("selectedPriscriptions");
  await store.clear();
  await store.add(data);
};
export const getSelectedPriscription = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("selectedPriscriptions", "readonly");
    const store = transaction.objectStore("selectedPriscriptions");
    const stores = store.getAll();
    stores.onsuccess = function (e) {
      resolve(e.target.result);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};
export const deleteSelectedPriscription = async (id) => {
  // console.log('id from indexdb', id);
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("selectedPriscriptions", "readwrite");
    const store = transaction.objectStore("selectedPriscriptions");
    // console.log('id from indexdb', id);
    await store.clear();
    store.onsuccess = function (e) {
      resolve("success");
    };
    store.onerror = function (e) {
      reject("error");
    };
  });
};

export const getPrescriptionByPatient = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("priscriptions", "readonly");
    const store = transaction.objectStore("priscriptions");

    const stores = store.getAll();
    stores.onsuccess = function (e) {
      let users = e.target.result;
      let matchingUsers = users.filter((user) => user.userLocalId === id);
      resolve(matchingUsers);
    };
    stores.onerror = (e) => {
      console.error(e?.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};

// Appointments
export const addAppointment = async (data) => {
  const transaction = db.transaction("appointments", "readwrite");
  const store = transaction.objectStore("appointments");
  await store.add(data);
};
export const editAppointment = async (data) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("appointments", "readwrite");
    const store = transaction.objectStore("appointments");
    // Get the patient list object that has this localID as its localID
    const objectStoreWithID = store.get(data.localID);
    objectStoreWithID.onsuccess = () => {
      // Grab the data object returned as the result by: objectStoreWithID.result
      const myData = data;
      // Create another request that inserts the item back into the myDatabase
      const updateTitleRequest = store.put(myData);
      // Log the transaction that originated this request
      return resolve(console.log("Updated"));
    };
    objectStoreWithID.onerror = (event) => {
      return reject(console.log({ event }));
    };
  });
};
export const getAppointment = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("appointments", "readonly");
    const store = transaction.objectStore("appointments");
    const stores = store.get(id);
    stores.onsuccess = function (e) {
      resolve(e.target.result);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};
export const getAllAppointment = async () => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("appointments", "readonly");
    const store = transaction.objectStore("appointments");
    const stores = store.getAll();
    stores.onsuccess = function (e) {
      resolve(e.target.result);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};
export const getAllAppointmentByID = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("appointments", "readonly");
    const store = transaction.objectStore("appointments", "userLocalId");

    const stores = store.getAll();
    stores.onsuccess = function (e) {
      let users = e.target.result;
      let matchingUsers = users.filter((user) => user.userLocalId === id);

      resolve(matchingUsers);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};
export const deleteAppointment = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("appointments", "readwrite");
    const store = transaction.objectStore("appointments");
    const objectStoreWithID = store.get(id);
    objectStoreWithID.onsuccess = () => {
      // Grab the data object returned as the result by: objectStoreWithID.result
      // const myData = data;
      // Create another request that inserts the item back into the myDatabase
      const updateTitleRequest = store.delete(id);
      // Log the transaction that originated this request
      return resolve(console.log("Deleted"));
    };
    objectStoreWithID.onerror = (event) => {
      return reject(console.log({ event }));
    };
  });
};
export const saveSelectedAppointment = async (data) => {
  const transaction = db.transaction("selectedAppointments", "readwrite");
  const store = transaction.objectStore("selectedAppointments");
  await store.clear();
  await store.add(data);
};
export const getSelectedAppointment = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("selectedAppointments", "readonly");
    const store = transaction.objectStore("selectedAppointments");
    const stores = store.getAll();
    stores.onsuccess = function (e) {
      resolve(e.target.result);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};
export const deleteSelectedAppointment = async (id) => {
  // console.log('id from indexdb', id);
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("selectedAppointments", "readwrite");
    const store = transaction.objectStore("selectedAppointments");
    // console.log('id from indexdb', id);
    await store.clear();
    store.onsuccess = function (e) {
      resolve("success");
    };
    store.onerror = function (e) {
      reject("error");
    };
  });
};

// Notes
export const addNotes = async (data) => {
  const transaction = db.transaction("patientNotes", "readwrite");
  const store = transaction.objectStore("patientNotes");
  await store.add(data);
};
export const editNotes = async (data) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("patientNotes", "readwrite");
    const store = transaction.objectStore("patientNotes");
    // Get the patient list object that has this localID as its localID
    const objectStoreWithID = store.get(data.localID);
    objectStoreWithID.onsuccess = () => {
      // Grab the data object returned as the result by: objectStoreWithID.result
      const myData = data;
      // Create another request that inserts the item back into the myDatabase
      const updateTitleRequest = store.put(myData);
      // Log the transaction that originated this request
      return resolve(console.log("Updated"));
    };
    objectStoreWithID.onerror = (event) => {
      return reject(console.log({ event }));
    };
  });
};
export const getNotes = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("patientNotes", "readonly");
    const store = transaction.objectStore("patientNotes");
    const stores = store.get(id);
    stores.onsuccess = function (e) {
      resolve(e.target.result);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};
export const getAllNotes = async () => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("patientNotes", "readonly");
    const store = transaction.objectStore("patientNotes");
    const stores = store.getAll();
    stores.onsuccess = function (e) {
      resolve(e.target.result);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};
export const getAllNotesByID = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("patientNotes", "readonly");
    const store = transaction.objectStore("patientNotes", "userLocalId");

    const stores = store.getAll();
    stores.onsuccess = function (e) {
      let users = e.target.result;
      let matchingUsers = users.filter((user) => user.userLocalId === id);
      // console.log({ matchingUsers, id });
      resolve(matchingUsers);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};
export const deleteNotes = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("patientNotes", "readwrite");
    const store = transaction.objectStore("patientNotes");
    const objectStoreWithID = store.get(id);
    objectStoreWithID.onsuccess = () => {
      // Grab the data object returned as the result by: objectStoreWithID.result
      // const myData = data;
      // Create another request that inserts the item back into the myDatabase
      const updateTitleRequest = store.delete(id);
      // Log the transaction that originated this request
      return resolve(console.log("Deleted"));
    };
    objectStoreWithID.onerror = (event) => {
      return reject(console.log({ event }));
    };
  });
};
export const saveSelectedNotes = async (data) => {
  const transaction = db.transaction("selectedpatient", "readwrite");
  const store = transaction.objectStore("selectedpatient");
  await store.clear();
  await store.add(data);
};
export const getSelectedNotes = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("selectedpatient", "readonly");
    const store = transaction.objectStore("selectedpatient");
    const stores = store.getAll();
    stores.onsuccess = function (e) {
      resolve(e.target.result);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};
export const deleteSelectedNotes = async (id) => {
  // console.log('id from indexdb', id);
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("selectedpatient", "readwrite");
    const store = transaction.objectStore("selectedpatient");
    // console.log('id from indexdb', id);
    await store.clear();
    store.onsuccess = function (e) {
      resolve("success");
    };
    store.onerror = function (e) {
      reject("error");
    };
  });
};

// Documents
export const addDocuments = async (data) => {
  const transaction = db.transaction("documents", "readwrite");
  const store = transaction.objectStore("documents");
  await store.add(data);
};
export const editDocuments = async (data) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("documents", "readwrite");
    const store = transaction.objectStore("documents");
    // Get the patient list object that has this localID as its localID
    const objectStoreWithID = store.get(data.localID);
    objectStoreWithID.onsuccess = () => {
      // Grab the data object returned as the result by: objectStoreWithID.result
      const myData = data;
      // Create another request that inserts the item back into the myDatabase
      const updateTitleRequest = store.put(myData);
      // Log the transaction that originated this request
      return resolve(console.log("Updated"));
    };
    objectStoreWithID.onerror = (event) => {
      return reject(console.log({ event }));
    };
  });
};
export const getDocuments = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("documents", "readonly");
    const store = transaction.objectStore("documents");
    const stores = store.get(id);
    stores.onsuccess = function (e) {
      resolve(e.target.result);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};
export const getAllDocuments = async () => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("documents", "readonly");
    const store = transaction.objectStore("documents");
    const stores = store.getAll();
    stores.onsuccess = function (e) {
      resolve(e.target.result);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};
export const getAllDocumentsByID = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("documents", "readonly");
    const store = transaction.objectStore("documents", "userLocalId");

    const stores = store.getAll();
    stores.onsuccess = function (e) {
      let users = e.target.result;
      let matchingUsers = users.filter((user) => user.userLocalId === id);
      // console.log({ matchingUsers, id });
      resolve(matchingUsers);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};
export const deleteDocuments = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("documents", "readwrite");
    const store = transaction.objectStore("documents");
    const objectStoreWithID = store.get(id);
    objectStoreWithID.onsuccess = () => {
      // Grab the data object returned as the result by: objectStoreWithID.result
      // const myData = data;
      // Create another request that inserts the item back into the myDatabase
      const updateTitleRequest = store.delete(id);
      // Log the transaction that originated this request
      return resolve(console.log("Deleted"));
    };
    objectStoreWithID.onerror = (event) => {
      return reject(console.log({ event }));
    };
  });
};
export const saveSelectedDocuments = async (data) => {
  const transaction = db.transaction("selectedpatient", "readwrite");
  const store = transaction.objectStore("selectedpatient");
  await store.clear();
  await store.add(data);
};
export const getSelectedDocuments = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("selectedpatient", "readonly");
    const store = transaction.objectStore("selectedpatient");
    const stores = store.getAll();
    stores.onsuccess = function (e) {
      resolve(e.target.result);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};
export const deleteSelectedDocuments = async (id) => {
  // console.log('id from indexdb', id);
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("selectedpatient", "readwrite");
    const store = transaction.objectStore("selectedpatient");
    // console.log('id from indexdb', id);
    await store.clear();
    store.onsuccess = function (e) {
      resolve("success");
    };
    store.onerror = function (e) {
      reject("error");
    };
  });
};

// Billings
export const addBilling = async (data) => {
  const transaction = db.transaction("billings", "readwrite");
  const store = transaction.objectStore("billings");
  await store.add(data);
};
export const editBilling = async (data) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("billings", "readwrite");
    const store = transaction.objectStore("billings");
    // Get the patient list object that has this localID as its localID
    console.log({ data });
    const objectStoreWithID = store.get(data?.localID);
    objectStoreWithID.onsuccess = () => {
      // Grab the data object returned as the result by: objectStoreWithID.result
      const myData = data;
      // Create another request that inserts the item back into the myDatabase
      const updateTitleRequest = store.put(myData);
      // Log the transaction that originated this request
      return resolve(console.log("Updated"));
    };
    objectStoreWithID.onerror = (event) => {
      return reject(console.log({ event }));
    };
  });
};
export const getBilling = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("billings", "readonly");
    const store = transaction.objectStore("billings");
    const stores = store.get(id);
    stores.onsuccess = function (e) {
      resolve(e.target.result);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};
export const getAllBilling = async () => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("billings", "readonly");
    const store = transaction.objectStore("billings");
    const stores = store.getAll();
    stores.onsuccess = function (e) {
      resolve(e.target.result);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};
export const getAllBillingsByID = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("billings", "readonly");
    const store = transaction.objectStore("billings", "userLocalId");

    const stores = store.getAll();
    stores.onsuccess = function (e) {
      let users = e.target.result;
      let matchingUsers = users.filter((user) => user.userLocalId === id);
      // console.log({ matchingUsers, id });
      resolve(matchingUsers);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};
export const deleteBilling = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("billings", "readwrite");
    const store = transaction.objectStore("billings");
    const objectStoreWithID = store.get(id);
    objectStoreWithID.onsuccess = () => {
      // Grab the data object returned as the result by: objectStoreWithID.result
      // const myData = data;
      // Create another request that inserts the item back into the myDatabase
      const updateTitleRequest = store.delete(id);
      // Log the transaction that originated this request
      return resolve(console.log("Deleted"));
    };
    objectStoreWithID.onerror = (event) => {
      return reject(console.log({ event }));
    };
  });
};
export const saveSelectedBilling = async (data) => {
  const transaction = db.transaction("selectedBilling", "readwrite");
  const store = transaction.objectStore("selectedBilling");
  await store.clear();
  await store.add(data);
};
export const getSelectedBilling = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("selectedBilling", "readonly");
    const store = transaction.objectStore("selectedBilling");
    const stores = store.getAll();
    stores.onsuccess = function (e) {
      resolve(e.target.result);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};
export const deleteSelectedBilling = async (id) => {
  // console.log('id from indexdb', id);
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("selectedBilling", "readwrite");
    const store = transaction.objectStore("selectedBilling");
    // console.log('id from indexdb', id);
    await store.clear();
    store.onsuccess = function (e) {
      resolve("success");
    };
    store.onerror = function (e) {
      reject("error");
    };
  });
};

// Invenory
export const addInventory = async (data) => {
  const transaction = db.transaction("inventory", "readwrite");
  const store = transaction.objectStore("inventory");
  await store.add(data);
};
export const editInventory = async (data) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("inventory", "readwrite");
    const store = transaction.objectStore("inventory");
    // Get the patient list object that has this localID as its localID
    const objectStoreWithID = store.get(data.localID);
    objectStoreWithID.onsuccess = () => {
      // Grab the data object returned as the result by: objectStoreWithID.result
      const myData = data;
      // Create another request that inserts the item back into the myDatabase
      const updateTitleRequest = store.put(myData);
      // Log the transaction that originated this request
      return resolve(console.log("Updated"));
    };
    objectStoreWithID.onerror = (event) => {
      return reject(console.log({ event }));
    };
  });
};
export const getInventory = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("inventory", "readonly");
    const store = transaction.objectStore("inventory");
    const stores = store.get(id);
    stores.onsuccess = function (e) {
      resolve(e.target.result);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};
export const getAllInventory = async () => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("inventory", "readonly");
    const store = transaction.objectStore("inventory");
    const stores = store.getAll();
    stores.onsuccess = function (e) {
      resolve(e.target.result);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};
export const getAllInventorysByID = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("inventory", "readonly");
    const store = transaction.objectStore("inventory", "userLocalId");

    const stores = store.getAll();
    stores.onsuccess = function (e) {
      let users = e.target.result;
      let matchingUsers = users.filter((user) => user.userLocalId === id);
      // console.log({ matchingUsers, id });
      resolve(matchingUsers);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};

export const deleteInventory = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("inventory", "readwrite");
    const store = transaction.objectStore("inventory");
    const objectStoreWithID = store.get(id);
    objectStoreWithID.onsuccess = () => {
      // Grab the data object returned as the result by: objectStoreWithID.result
      // const myData = data;
      // Create another request that inserts the item back into the myDatabase
      const updateTitleRequest = store.delete(id);
      // Log the transaction that originated this request
      return resolve(console.log("Deleted"));
    };
    objectStoreWithID.onerror = (event) => {
      return reject(console.log({ event }));
    };
  });
};

export const saveSelectedInventory = async (data) => {
  const transaction = db.transaction("selectedInventory", "readwrite");
  const store = transaction.objectStore("selectedInventory");
  await store.clear();
  await store.add(data);
};

export const getSelectedInventory = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("selectedInventory", "readonly");
    const store = transaction.objectStore("selectedInventory");
    const stores = store.getAll();
    stores.onsuccess = function (e) {
      resolve(e.target.result);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};

export const deleteSelectedInventory = async (id) => {
  // console.log('id from indexdb', id);
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("selectedInventory", "readwrite");
    const store = transaction.objectStore("selectedInventory");
    // console.log('id from indexdb', id);
    await store.clear();
    store.onsuccess = function (e) {
      resolve("success");
    };
    store.onerror = function (e) {
      reject("error");
    };
  });
};

// Partners
export const addPartner = async (data) => {
  const transaction = db.transaction("partner", "readwrite");
  const store = transaction.objectStore("partner");
  await store.add(data);
};
export const editPartner = async (data) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("partner", "readwrite");
    const store = transaction.objectStore("partner");
    // Get the patient list object that has this localID as its localID
    const objectStoreWithID = store.get(data.localID);
    objectStoreWithID.onsuccess = () => {
      // Grab the data object returned as the result by: objectStoreWithID.result
      const myData = data;
      // Create another request that inserts the item back into the myDatabase
      const updateTitleRequest = store.put(myData);
      // Log the transaction that originated this request
      return resolve(console.log("Updated"));
    };
    objectStoreWithID.onerror = (event) => {
      return reject(console.log({ event }));
    };
  });
};
export const getPartner = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("partner", "readonly");
    const store = transaction.objectStore("partner");
    const stores = store.get(id);
    stores.onsuccess = function (e) {
      resolve(e.target.result);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};
export const getAllPartner = async () => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("partner", "readonly");
    const store = transaction.objectStore("partner");
    const stores = store.getAll();
    stores.onsuccess = function (e) {
      resolve(e.target.result);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};
export const getAllAppoPartner = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("partner", "readonly");
    const store = transaction.objectStore("partner", "userLocalId");

    const stores = store.getAll();
    stores.onsuccess = function (e) {
      let users = e.target.result;
      let matchingUsers = users.filter((user) => user.userLocalId === id);

      resolve(matchingUsers);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};
export const deletePartner = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("partner", "readwrite");
    const store = transaction.objectStore("partner");
    const objectStoreWithID = store.get(id);
    objectStoreWithID.onsuccess = () => {
      // Grab the data object returned as the result by: objectStoreWithID.result
      // const myData = data;
      // Create another request that inserts the item back into the myDatabase
      const updateTitleRequest = store.delete(id);
      // Log the transaction that originated this request
      return resolve(console.log("Deleted"));
    };
    objectStoreWithID.onerror = (event) => {
      return reject(console.log({ event }));
    };
  });
};
export const saveSelectedPartner = async (data) => {
  const transaction = db.transaction("selectedPartner", "readwrite");
  const store = transaction.objectStore("selectedPartner");
  await store.clear();
  await store.add(data);
};
export const getSelectedPartner = async (id) => {
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("selectedPartner", "readonly");
    const store = transaction.objectStore("selectedPartner");
    const stores = store.getAll();
    stores.onsuccess = function (e) {
      resolve(e.target.result);
    };
    stores.onerror = (e) => {
      console.error(e.message, "error happened");
      reject(e.message);
    };
    return stores;
  });
};
export const deleteSelectedPartner = async (id) => {
  // console.log('id from indexdb', id);
  return new Promise(async (resolve, reject) => {
    const transaction = db.transaction("selectedPartner", "readwrite");
    const store = transaction.objectStore("selectedPartner");
    // console.log('id from indexdb', id);
    await store.clear();
    store.onsuccess = function (e) {
      resolve("success");
    };
    store.onerror = function (e) {
      reject("error");
    };
  });
};

export default {
  addPatient,
  getPatient,
  getAllPatients,
  deletePatient,
  getSelectedPatient,
  saveSelectedPatient,
  editPatient,

  addPriscription,
  getPriscriptions,
  getAllPriscriptions,
  deletePriscription,
  getSelectedPriscription,
  saveSelectedPriscription,
  editPriscriptions,
  getPrescriptionByPatient,

  addAppointment,
  editAppointment,
  getAppointment,
  getAllAppointment,
  deleteAppointment,
  saveSelectedAppointment,
  getSelectedAppointment,
  deleteSelectedAppointment,

  addNotes,
  editNotes,
  getNotes,
  getAllNotes,
  getAllNotesByID,
  deleteNotes,
  saveSelectedNotes,
  getSelectedNotes,
  deleteSelectedNotes,

  addDocuments,
  editDocuments,
  getDocuments,
  getAllDocuments,
  getAllDocumentsByID,
  deleteDocuments,

  addBilling,
  editBilling,
  getBilling,
  getAllBilling,
  deleteBilling,
  saveSelectedBilling,
  getSelectedBilling,
  deleteSelectedBilling,

  addInventory,
  editInventory,
  getInventory,
  getAllInventory,
  deleteInventory,
  saveSelectedInventory,
  getSelectedInventory,
  deleteSelectedInventory,

  addPartner,
  editPartner,
  getPartner,
  getAllPartner,
  deletePartner,
  saveSelectedPartner,
  getSelectedPartner,
  deleteSelectedPartner,
};

// In Components
// const [todos, setTodos] = useState([]);

// const addPatient = async (data) => {
//   // ... Use the addPatient function here
//   setTodos([...todos, data]);
// };

// return (
//   <div>
//     {/* ... Form to add new todos */}
//     <ul>
//       {todos.map((todo) => (
//         <li key={todo.id}>{todo.title}</li>
//       ))}
//     </ul>
//   </div>
// );
